import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { LoadingScreenService } from '@shared/domain/loading-screen.service';

export const loadingScreenInitializerProvider: EnvironmentProviders = provideAppInitializer(() => {
  inject(LoadingScreenService);
});
